import React from 'react';
import { Container, Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PersonPlus, People } from 'react-bootstrap-icons';

function Admin() {
  return (
    <Container className="mt-4" style={{ maxWidth: '700px' }}>
      <h2 className="mb-4">🔐 Admin Settings</h2>

      <Card className="shadow-sm">
        <Card.Header className="fw-bold">
          <People className="me-2" />
          User Management
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroup.Item
            as={Link}
            to="/users/add"
            className="text-decoration-none"
            action
          >
            <PersonPlus className="me-2" />
            Add User
          </ListGroup.Item>
          {/* Future admin features */}
          <ListGroup.Item disabled>
            Manage Roles & Permissions (coming soon)
          </ListGroup.Item>
        </ListGroup>
      </Card>
    </Container>
  );
}

export default Admin;
